/**
 * EmptyState — 빈 상태 안내 컴포넌트
 *
 * - 아이콘, 제목, 설명, 액션 슬롯으로 구성된 중앙 정렬 레이아웃
 */

import { ReactNode } from 'react'
import { cn } from '../../lib/cn.js'
import styles from './EmptyState.module.css'

interface EmptyStateProps {
  icon?: ReactNode
  title: string
  description?: string
  action?: ReactNode
  className?: string
}

export function EmptyState({ icon, title, description, action, className }: EmptyStateProps) {
  return (
    <div className={cn(styles.root, className)}>
      {icon && <div className={styles.icon}>{icon}</div>}
      <p className={styles.title}>{title}</p>
      {description && <p className={styles.description}>{description}</p>}
      {action && <div className={styles.action}>{action}</div>}
    </div>
  )
}
